// extracted by mini-css-extract-plugin
export default {"overlay":"Nz-z","bodyOpen":"Oz-z","content":"Pz-z","header":"Qz-z","close":"Rz-z","closeNoHeading":"Sz-z"};